import { ChangeDetectionStrategy, Component, inject, linkedSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../../../shared/services/auth.service';
import { SucursalesService } from '../../../configuration/services/sucursales.service';
import { Select } from '../../../../shared/components/select/select';

@Component({
  selector: 'app-sucursal-selector',
  standalone: true,
  imports: [Select, FormsModule],
  templateUrl: './sucursal-selector.html',
  styleUrl: './sucursal-selector.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SucursalSelector {
  readonly activeModal = inject(NgbActiveModal);
  readonly authService = inject(AuthService);
  private readonly sucursalesService = inject(SucursalesService);
  readonly sucursales = this.sucursalesService.resources.getList();

  confirm(): void {

    this.activeModal.close(this.selectedSucursal());
  }

  readonly selectedSucursal = linkedSignal<number | undefined>(() => {
    if (this.sucursales.hasValue()) {
      let sucursalName = this.authService.getSucursalName();
      let sucursales = this.sucursales.value().filter(s => s.nombre !== sucursalName);
      return sucursales?.length >= 0 ? sucursales[0].sucursalId : undefined;
    }
    return undefined;
  });

}
